import { isNumberValid } from '@growth/auth-helpers';
import { docSessionStorage } from '@growth/browser-storage';
import pdtTrack from '@growth/pdt-track';

var validatePincode = function validatePincode(value) {
  return isNumberValid(Number(value)) && value.length === 6;
};

var OnceSessionName = "user-billing-details-fetched";
var pincodeErrorMessage = 'pincode should be 6 digit number';
var stateMandatoryMessage = 'State is mandatory.';
var checkBoxErrorMessage = 'checkbox need to be checked';
var apiErrorMessage = 'Something went wrong. please try again';

// sort the statelist on the basis of name

var stateList = [{
  name: 'Andaman and Nicobar',
  id: 'STANN'
}, {
  name: 'Andhra Pradesh',
  id: 'STADP'
}, {
  name: 'Arunachal Pradesh',
  id: 'STACP'
}, {
  name: 'Assam',
  id: 'STASAM'
}, {
  name: 'Bihar',
  id: 'STBHIR'
}, {
  name: 'Chandigarh',
  id: 'STIXC'
}, {
  name: 'Chhattisgarh',
  id: 'STCHGH'
}, {
  name: 'Dadra and Nagar Haveli',
  id: 'STDNH'
}, {
  name: 'Daman and Diu',
  id: 'STDAMA'
}, {
  name: 'Delhi',
  id: 'STDEL'
}, {
  name: 'Goa',
  id: 'STGOA'
}, {
  name: 'Gujarat',
  id: 'STGJ'
}, {
  name: 'Haryana',
  id: 'STHR'
}, {
  name: 'Himachal Pradesh',
  id: 'STHP'
}, {
  name: 'Jammu and Kashmir',
  id: 'STJK'
}, {
  name: 'Jharkhand',
  id: 'STJHKD'
}, {
  name: 'Karnataka',
  id: 'STKR'
}, {
  name: 'Kerala',
  id: 'STKRLA'
}, {
  name: 'Ladakh',
  id: 'STLADA'
}, {
  name: 'Lakshadweep',
  id: 'STLKDP'
}, {
  name: 'Madhya Pradesh',
  id: 'STMP'
}, {
  name: 'Maharashtra',
  id: 'STMHRA'
}, {
  name: 'Manipur',
  id: 'STMNPR'
}, {
  name: 'Meghalaya',
  id: 'STMGYA'
}, {
  name: 'Mizoram',
  id: 'STMZM'
}, {
  name: 'Nagaland',
  id: 'STNAGL'
}, {
  name: 'Odisha',
  id: 'STODSA'
}, {
  name: 'Puducherry',
  id: 'STPDCY'
}, {
  name: 'Punjab',
  id: 'STPB'
}, {
  name: 'Rajasthan',
  id: 'STRAJ'
}, {
  name: 'Sikkim',
  id: 'STSKKM'
}, {
  name: 'Tamil Nadu',
  id: 'STTN'
}, {
  name: 'Telangana',
  id: 'STTLGA'
}, {
  name: 'Tripura',
  id: 'STTRIP'
}, {
  name: 'Uttar Pradesh',
  id: 'STUP'
}, {
  name: 'Uttarakhand',
  id: 'STUKND'
}, {
  name: 'West Bengal',
  id: 'STWB'
}, {
  name: 'Outside India',
  id: 'OTH'
}];
var heading = 'Your pincode and state';
var subHeadingDweb = '(Required for GST purpose on your tax invoice. You can edit this anytime later in your profile section. )';
var subHeadingMweb = 'Required for GST purpose on your tax invoice.';
var Platform = {
  dweb: 'dweb',
  mweb: 'mweb'
};

var getOnceSession = function getOnceSession() {
  return docSessionStorage.getItem(OnceSessionName);
};
var setOnceSession = function setOnceSession() {
  return docSessionStorage.setItem(OnceSessionName, true);
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var pdt = function () {
  var commonKeys;
  return {
    setCommonKeys: function setCommonKeys(_ref) {
      var lobName = _ref.lobName;
      commonKeys = {
        event_details: {
          lob: lobName
        },
        device: {
          traffic_source: 'direct'
        }
      };
    },
    sendPdtEvent: function sendPdtEvent(eventDetails) {
      pdtTrack({
        event_details: _extends({}, commonKeys.event_details, eventDetails),
        device: commonKeys.device
      });
    }
  };
}();

export { OnceSessionName as O, Platform as P, stateList as a, setOnceSession as b, pincodeErrorMessage as c, checkBoxErrorMessage as d, stateMandatoryMessage as e, apiErrorMessage as f, getOnceSession as g, heading as h, subHeadingMweb as i, pdt as p, subHeadingDweb as s, validatePincode as v };
